import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import CovidDeclaration from './Component/CovidDeclaration';
import { change, destroy, reset } from 'redux-form'
import Phi from '../../Phi/Phi';
import Constants from '../../Phi/Constants';

function getAssociationCandidate(profile, organization, role, child, selected){

    let selectedUserId, selectedOrganizationId, selectedUserRoleId

    if (child && child.length) {
        let selectedChild = child[selected]

        selectedUserId = selectedChild.userId
        selectedOrganizationId = selectedChild.schoolId || Constants.covidDeclarationDefaultOrganization
        selectedUserRoleId = selectedChild.role || Constants.roleIdMap.STUDENT
    }else {
        selectedUserId = profile.userId
        selectedOrganizationId = organization.org_id || Constants.covidDeclarationDefaultOrganization
        selectedUserRoleId = role.role_type_id
    }

    return {
        selectedUserId, 
        selectedOrganizationId,
        selectedUserRoleId
    }
} 

const mapStateToProps = (state, ownProps) => {

    let userOrganization = Phi.Storage.getItem('organization')
    let userProfile = Phi.Storage.getItem('profile')
    let userRole = Phi.Storage.getItem('roles')

    let childList = state.child.childList || []
    let selectedChild = state.child.selectedChild || 0

    userOrganization = userOrganization && JSON.parse(userOrganization) && JSON.parse(userOrganization)[0] || {}
    userProfile = state.auth.userProfile || {}
    userRole = userRole && JSON.parse(userRole)[0] || {}

    let { selectedUserId, selectedOrganizationId, selectedUserRoleId } = getAssociationCandidate(userProfile, userOrganization, userRole, childList, selectedChild)

    return {

        selectedUserId,
        selectedOrganizationId,
        selectedUserRoleId,

        userOrganization,
        userProfile,
        userRole,

        childList,
        selectedChild,

        responseCovidDeclarationForm: state.child.responseCovidDeclarationForm,
        responseCovidDeclarationList: state.child.responseCovidDeclarationList || {},
    
        formData: state.form.formData,

        organization: state.organization.currentOrganization,
        covidGlobalDashboard: state.organization.covidGlobalDashboard || {},
    }
};


const mapDispatchToProps = (dispatch) => ({
    postCovidDeclarationForm: (studentId, organizationId, payload, file, roleType) => dispatch(Actions.postCovidDeclarationForm(studentId, organizationId, payload, file, roleType)),
    getCovidDeclarationList: (params) => dispatch(Actions.getCovidDeclarationList(params)), 

    clearForm: () => dispatch(destroy('customForm')),
    initializeForm: (formData) => dispatch(Actions.initializeForm(formData)),
    changeFieldValue: (field, value) => dispatch(change('customForm', field, value)),

    fetchOrganization: (organizationId) => dispatch(Actions.getOrganization(organizationId)), 
    getCovidGlobalDashboard: (state, city) => dispatch(Actions.getCovidGlobalDashboard(state, city)),

    changeLocation: (location) => dispatch(Actions.changeCurrentLocation(location)),

    sendFirstDeclarationEmail: (template, recipient, variables) => dispatch(Actions.sendEmail(template, recipient, variables))
});


export default connect(mapStateToProps, mapDispatchToProps)(CovidDeclaration)